import authBaseHttpRequest from './authBaseHttpRequest';

export const fetchFailedRedemptions = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/dashboard/stats/failed-redemption/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const batchRetryRedeemReward = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/support/batch-retry-redeem/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const fetchRetryRedeemJobStatus = ({ params }) => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/support/batch-retry-status/?task_id=${params?.taskId ?? params?.task_id}`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const fetchMergeWalletData = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/support/verify-caregiver/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const mergeWallet = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/support/merge-account/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const fetchCaregiverByPhone = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/support/fetch-caregiver-by-phone/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const changeEmployeePassword = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/support/update-employee-password/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const fetchRewardConfigList = ({ params }) => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/reward-config-list/`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const manualRedemption = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/support/add-manual-redemption/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const updatePrimaryPhone = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/support/update-primary-phone/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const fetchTangoTotalBalance = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/support/tango-total-balance/`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

